<template>
  <div class="directchat">
    <div class="directchat__topcontent" :class="{'global__bc_purple' : custDetail && custDetail.service_head === 'AIR', 'global__bc_deepgreen' : custDetail && custDetail.service_head === 'LAND'}">
      <div class="col-md p-0">
        <span class="row m-0 align-items-center">
          <div @click="showUserList = !showUserList" style="width: 88%; cursor: pointer;"
          class="d-flex align-items-center">
            <p class="px-3 directchat__topcontent--text">CHAT ROOM</p>
          </div>
        </span>
      </div>
    </div>
    <div class="directchat__content">
      <div class="align-items-end h-100">
        <div class="col-md text-center" v-if="isLoadingMessages">
          <b-spinner small variant="secondary"></b-spinner>
        </div>
        <div class="col-md p-0 test h-100" v-else-if="custDetail">
          <div class="box__chatting global__scrollcustom"
            :class="isDisableChat() ? 'box__disabled' : ''"
            v-chat-scroll="{smooth: true, notSmoothOnInit: true}"
          >
            <div class="">
              <div :class="getBubbleRowClass(message.sender.username)"  v-for="(message, index) in messages" :key="`${index}-A`">
                <div :class="getBubbleColClass(message.sender.username)">
                  <div :class="getBubbleContent(message.sender.username)">
                    <!-- admin bubble -->
                    <div class="bubble__icon text-center"
                         v-if="message.sender.username !== profile.customerUsername">
                      <img class="" v-if="message.sender.comptp === 'USER' && custDetail.service_head === 'AIR'"
                      src="@/assets/image/image/Customer Default Photo Air.png" alt="">
                      <img class="" v-else-if="message.sender.comptp === 'USER'"
                      src="@/assets/image/image/Customer Default Photo.png" alt="">
                      <img class="" v-else-if="message.sender.comptp === 'VENDOR'"
                      src="@/assets/image/image/Vendor Default Photo.png" alt="">
                      <img class="" v-else
                      src="@/assets/image/image/Admin Default Photo.png" alt="">
                      <p class="bubble__username">
                          {{ message.sender.fullname ? message.sender.fullname
                          : message.sender.username }}
                      </p>
                    </div>
                    <!-- end admin bubble -->
                    <div :class="getBubbleSizeClass(message.sender.username)">
                      <p :class="message.sender.username === profile.customerUsername
                                  ? 'time__bubble2' : 'time__bubble'">
                        {{ getMessageDate(message.createdAt) }}
                        <span>{{ getMessageTime(message.createdAt) }}</span>
                      </p>
                      <div :class="getBubbleColorClass(message.sender.username)">
                        <div class="d-flex flex-row uploadfile"
                        v-if="message.attachment !== null">
                          <img :class="message.sender.username === profile.customerUsername
                            ? 'uploadfile__icon' : ''" @click.prevent="downloadDoc(message.shipmentId, message.orderNumber, message.attachment.type.split('/')[ 0 ], message.attachment.type.split('/')[ 1 ], message.attachment.fileId)"
                            :src="message.attachment.type !== 'undefined/undefined' ? getIconFile(message.attachment.type) : null" alt="" height="28px">
                          <div class="uploadfile pl-3">
                            <p :class="message.sender.username === profile.customerUsername
                                  ? 'uploadfile__desc' : 'uploadfile__desc2'">
                                  File Name: {{ message.attachment.type.replace("/","") }}</p>
                            <p :class="message.sender.username === profile.customerUsername
                                  ? 'uploadfile__desc' : 'uploadfile__desc2'">
                                File Category: {{ message.attachment.fileDesc }}</p>
                          </div>
                        </div>
                        <div v-if="message.attachment === null"
                              :class="message.sender.username === profile.customerUsername && custDetail.service_head === 'AIR'
                              ? 'bubble__text3' : message.sender.username === profile.customerUsername ? 'bubble__text2' : 'bubble__text'">
                          <div v-if="message.replyOf && message.replyOf.body">
                            <div class="row m-0 reply__mesage">
                              <span>{{message.replyOf.from}}:</span>
                              <span class="pl-1">{{message.replyOf.body}}</span>
                            </div>
                            {{removeOldReply(message.body)}}
                          </div>
                          <div v-else>{{message.body}}</div>
                        </div>
                        <!-- v-show="isHoveReplyMsg == index" -->
                        <div :class="message.sender.username === profile.customerUsername
                              ? 'bubble__reply2' : 'bubble__reply'" v-if="!isDisableChat()"
                              @click.prevent="repplyMessages(message)">
                          <img src="@/assets/image/icon/message-reply-arrow.svg" alt="">
                          <p>Reply</p>
                        </div>
                      </div>
                    </div>

                    <div class="bubble__icon mr-3 text-center"
                          v-if="message.sender.username === profile.customerUsername">
                      <img class="" v-if="message.sender.username === profile.customerUsername && custDetail.service_head === 'AIR'"
                      src="@/assets/image/image/Customer Default Photo Air.png" alt="">
                      <img class="" v-else-if="message.sender.comptp === 'USER'"
                      src="@/assets/image/image/Customer Default Photo.png" alt="">
                      <img class="" v-else-if="message.sender.comptp === 'VENDOR'"
                      src="@/assets/image/image/Vendor Default Photo.png" alt="">
                      <img class="" v-else
                      src="@/assets/image/image/Admin Default Photo.png" alt="">
                      <p class="bubble__username2">
                        {{ message.sender.fullname ? message.sender.fullname
                        : message.sender.username }}
                      </p>
                    </div>
                    <!-- end your bubble -->

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isReplyMsg" class="directchat__content--reply">
            <span class="close" @click="resetMessage()">&times;</span>
            <div class="reply__container">
              <h5>{{replyOf.from}}</h5>
              <h6>{{removeOldReply(replyOf.body)}}</h6>
            </div>
          </div>
          <form id="sendmessages" @submit.prevent="sendMessages()">
            <div class="row m-0 directchat__content--send"
            :class="isDisableChat() ? 'chat__disabled' : ''">
              <div class="col-md input" v-if="!isDisableChat()">
                <div class="row m-0 input__container">
                  <b-form-textarea class=""
                    max-rows="3" v-model="text"
                    v-on:keyup="validateEmailAddress"
                    placeholder="Enter your message">
                  </b-form-textarea>
                  <div class="input__button">
                    <div class="button__upload">
                      <img src="@/assets/image/icon/chat-attachment.svg" alt=""
                            @click="uploadfile()">
                    </div>
                    <button type="submit" name="button"
                      class="button__bluecorporite"
                      :disabled="removelinebreaks(text) === ''">
                      <img class=""  src="@/assets/image/icon/next.svg" alt="">
                    </button>
                  </div>
                </div>
              </div>
              <div class="chat__disabled" v-else>
                <p>Chat disabled , you can only view your history chat now</p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import * as momentTimezone from 'moment-timezone'
import mixinFileExt from '@/mixin/getters/file-extention'
import mixinGetStatus from '@/mixin/getters/status-bid'
import DOMPurify from 'dompurify'

export default {
  name: 'DirectChat',
  props: {
    custDetail: Object,
    typeRequest: String
  },
  data () {
    return {
      text: '',
      isReplyMsg: false,
      replyOf: {
        body: '',
        from: ''
      },
      iqId: this.$route.params.id_iq,
      iqNumber: this.$route.params.iqNumber,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      checkdate: '',
      theday: '',
      totalActiveUser: 0,
      showUserList: false
    }
  },
  mixins: [mixinFileExt, mixinGetStatus],
  computed: {
    ...mapGetters({
      // get user logged profile
      profile: 'auth/profile',
      // get chat messages
      messages: 'chat/messages',
      isLoadingMessages: 'chat/isLoadingMessages',
      errorMessages: 'chat/errorMessages',
      // get chat subscribers
      subscribers: 'chat/subscribers',
      isLoadingFetchSubscribers: 'chat/isLoadingFetchSubscribers',
      errorFetchSubscribers: 'chat/errorFetchSubscribers',
      // post chat subscribers
      isLoadingPostSubscribers: 'chat/isLoadingPostSubscribers',
      errorPostSubscribers: 'chat/errorPostSubscribers'
    })
  },
  watch: {
    '$route.params.iq_id': function () {
      this.fetchChannelSubscribers()
    },
    subscribers (data) {
      if (data.length === 0) {
        this.postSubscribers()
      } else {
        this.fetchChannels()
      }
    }
  },
  mounted () {
    this.fetchChannelSubscribers()
  },
  methods: {
    validateEmailAddress (event) { // use shift + enter for break line, use enter for send
      if (event.keyCode === 13 && event.shiftKey === false) {
        this.sendMessages()
      }
    },
    isDisableChat () {
      if (this.custDetail) {
        return this.getStatus(this.custDetail) === 'Completed'
      }
    },
    removelinebreaks (text) {
      return text.replace(/[\r\n]+/gm, '')
    },
    uploadfile: function () {
      const id = this.iqId
      const referenceNumber = this.iqNumber.split('-').join('/')
      const type = 'INSTANT-REQUEST'
      this.$eventHub.$emit('dialog-upload-attachment', {id, referenceNumber, type})
    },
    getRowClass (username) {
      return username !== this.profile.customerUsername ? 'row ml-0 content__merchant' : 'row justify-content-end content__customer'
    },
    getBubbleRowClass (username) {
      return username !== this.profile.customerUsername ? 'content__merchant' : 'content__customer d-flex justify-content-end'
    },
    getBubbleColClass (username) {
      return username !== this.profile.customerUsername ? 'col-md p-0 pl-3' : 'col-md p-0'
    },
    getBubbleContent (username) {
      return username !== this.profile.customerUsername ? 'content__customer row m-0 mb-5 justify-content-start' : 'content__customer row justify-content-end m-0 mb-5'
    },
    getBubbleSizeClass (username) {
      return username !== this.profile.customerUsername ? 'content__customer bubble' : 'content__customer bubble bubblemargin'
    },
    getBubbleColorClass (username) {
      return username !== this.profile.customerUsername ? 'bg__gray' : this.custDetail && this.custDetail.service_head === 'AIR' ? 'bg__purple' : 'bg__blue'
    },
    getLoggedUser (fullname, userName, comptp) {
      let username = ''
      if (userName === this.profile.customerUsername && comptp !== 'GUEST') {
        username = this.profile.customerName
      } else if (userName === this.profile.customerUsername && comptp === 'GUEST') {
        username = this.profile.customerName || this.profile.customerUsername
      } else {
        username = fullname || userName
      }
      return username
    },
    getMessageTime (date) {
      const newTime = momentTimezone(date).tz(this.timezone).format('HH:mm')
      return newTime
    },
    getMessageDate (date) {
      const newDate = momentTimezone(date).tz(this.timezone).format('DD MMM YYYY')
      const today = momentTimezone().tz(this.timezone).format('DD MMM YYYY')
      if (today === newDate) {
        return 'Today'
      } else {
        return newDate
      }
    },
    getDate (date) {
      return moment(date).format('ddd, MMM DD')
    },
    checkDate (date) {
      if (moment(this.getDate(date), 'ddd, MMM DD').isValid()) {
        const iscurrentDate = moment(date).isSame(moment(), 'day')
        const duration = moment.duration({'days': 1})
        const isyesterday = moment(duration).isBefore(moment(), 'day')
        if (iscurrentDate) {
          return 'Today'
        } else if (isyesterday) {
          return 'Yesterday'
        } else {
          return this.getDate(date)
        }
      } else {
        return 'not found'
      }
    },
    showdate (date) {
      if (this.theday !== date) {
        this.theday = date
        return true
      } else {
        // this.theday = date
        return false
      }
    },
    fetchChannels () {
      const token = localStorage.getItem('token')
      const shipmentId = this.iqId
      const orderNumber = this.iqNumber.split('-').join('/')
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS', { token, shipmentId, orderNumber }).then(() => {
        this.fetchMessages()
      })
    },
    fetchChannelSubscribers () {
      const shipmentId = this.iqId
      const orderNumber = this.iqNumber
      const typeMessage = 'instant-request'
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS', {shipmentId, orderNumber, typeMessage})
    },
    fetchMessages () {
      const shipmentId = this.iqId
      const orderNumber = this.iqNumber
      const typeMessage = 'instant-request'
      this.$store.dispatch('chat/WEBSOCKET_FETCH_MESSAGES', {shipmentId, orderNumber, typeMessage})
    },
    postSubscribers () {
      const typeMessage = 'instant-request'
      const orderNumber = this.iqNumber.split('-').join('/')
      const payload = {
        shipmentId: parseInt(this.iqId, 10),
        orderNumber
      }
      this.$store.dispatch('chat/WEBSOCKET_POST_CHANNELS_SUBSCRIBERS', { payload, typeMessage }).then(() => {
        this.fetchChannels()
      })
    },
    resetMessage () {
      this.replyOf.from = ''
      this.replyOf.body = ''
      this.isReplyMsg = false
    },
    repplyMessages (message) {
      this.replyOf.body = message.body
      this.replyOf.from = message.sender.fullname
        ? message.sender.fullname : message.sender.username
      this.isReplyMsg = true
    },
    removeOldReply (message) { // remove tag just for display
      if (message.split('</p>')) {
        const arrBodysplittag = message.split('</p>')
        return arrBodysplittag[arrBodysplittag.length - 1]
      }
      return message
    },
    sendMessages () {
      if (this.removelinebreaks(this.text) !== '') {
        const typeMessage = 'instant-request'
        const messageBody = DOMPurify.sanitize(this.text)
        const replyOf = Object.assign({}, this.replyOf)
        const payload = {
          messageBody,
          shipmentId: parseInt(this.iqId, 10),
          orderNumber: this.iqNumber.split('-').join('/'),
          reply: { to: 'admin' },
          replyOf
        }
        this.$store.dispatch('chat/WEBSOCKET_SEND_MESSAGE', { payload, typeMessage })
        this.messages.push({
          sender: {
            username: this.profile.customerUsername,
            fullname: this.profile.customerName,
            createdAt: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
            comptp: this.profile.compTp
          },
          body: messageBody,
          replyOf: this.isReplyMsg ? replyOf : null,
          attachment: null
        })
        this.text = ''
        this.resetMessage()
      }
    },
    downloadDoc (id, iqNumber, fileCategory, fileExt, fileId) {
      const shipmentId = id
      const type = 'INSTANT-REQUEST'
      const fileName = `${iqNumber}_${fileCategory}${fileExt}`
      const orderNumber = iqNumber.split('/').join('-')
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_DOCUMENT', {shipmentId, orderNumber, type, fileName, fileCategory, fileId})
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    action: function (data) {
      const requestId = this.iqId || this.contractId
      if (data.type === 'RECEIVE_WEBSOCKET_UPDATE_SHIPMENT_MESSAGES') {
        if (data.payload.response.message.sender.username !== this.profile.customerUsername) {
          if ((data.payload.response.message.sender.comptp === 'ANDALIN' && data.payload.response.message.reply.to === 'customer' && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10)) || (data.payload.response.message.sender.comptp === 'USER' && data.payload.response.message.reply.to === 'admin' && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10))) {
            const newData = data.payload.response.message
            this.messages.push(newData)
          }
        }
      }
      if (data.type === 'RECEIVE_WEBSOCKET_UPDATE_SHIPMENT_DOCUMENTS') {
        if ((data.payload.response.message.sender.comptp === 'ANDALIN' && data.payload.response.message.reply.to === 'customer' && !data.payload.response.message.reply.vendorId && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10)) || (data.payload.response.message.sender.comptp === 'USER' && data.payload.response.message.reply.to === 'admin' && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10))) {
          const newData = data.payload.response.message
          this.messages.push(newData)
          this.$eventHub.$emit('dialog-mgshipement-upload-hide')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail-instant-quote/GroupChat.vue